export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2424e315-bdf4-49b4-a967-bf83227be14e';
export const MODAL_CLOSE_SEC = 1.5;
